import * as Ariakit from '@ariakit/react';
import { createContext } from 'react';

export const ModalForceMountContext = createContext(false);

export const ModalForceMountProvider = ModalForceMountContext.Provider;

export type ModalDialogContextValue = {
  store: Ariakit.DialogStore;
  modal: boolean;
};

export const ModalDialogContext = createContext<ModalDialogContextValue | null>(null);

export const ModalDialogProvider = ModalDialogContext.Provider;
